<template>
  <div id="config-services-wrapper">
    <item-tile
      v-for="(item, index) in services"
      :key="index"
      class="service-item"
      :heading="item.name"
      :photo="item.photo"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="service-item"
      :selected="false"
      heading="Add New Service"
      @click="toggleCreationActive"
    />
    <service-creation
      v-if="creationActive"
      :service="edit.service"
      @close="toggleCreationActive"
      @add-service="callDb"
    />
    <service-delete
      v-if="del.service"
      :subject="del.service"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import ServiceCreation from "./Modals/Services/ServiceCreation.vue";
import ServiceDelete from "./Modals/Services/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        service: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        service: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    services() {
      return this.$store.getters.services;
    },
  },
  methods: {
    toggleCreationActive() {
      this.creationActive = !this.creationActive;
    },
    fillArrays(subject) {
      return {
        ...subject,
        forms: subject.forms.map((subjectForm) => {
          return this.$store.getters.forms.find((storeForm) => {
            return (
              subjectForm === storeForm.id || subjectForm === storeForm.name
            );
          });
        }),
        contracts: subject.contracts.map((subjectContract) => {
          return this.$store.getters.contracts.find((storeContract) => {
            return (
              subjectContract === storeContract.id ||
              subjectContract === storeContract.name
            );
          });
        }),
      };
    },
    initiateEdit(item, index) {
      this.edit.service = this.fillArrays(item);
      this.edit.index = index;
      this.toggleCreationActive();
    },
    initiateDelete(item, index) {
      this.del.service = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        service: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      await this.$store.dispatch("updateConfig", {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        index: this.del.index,
        category: "services",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      });
      this.closeDelete();
    },
    async callDb(subject) {
      let dbService = {
        name: subject.name,
        description: subject.description,
        priceOption: subject.priceOption,
        pricing: subject.pricing,
        employeesRequired: subject.employeesRequired,
        photo: subject.photo,
        id: subject.id ? subject.id : "service" + new Date().getTime(),
        forms: subject.forms
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
        contracts: subject.contracts
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
      };
      if (dbService.photo && typeof dbService.photo !== "string") {
        await this.$store.dispatch("addPhoto", dbService.photo).then((res) => {
          dbService.photo = res;
        });
      }
      let updatePacket;
      if (this.edit.index) {
        updatePacket = {
          key: {
            userId: this.$store.state.user.userId,
            tenantId: this.$store.state.user.tenantId,
          },
          subject: dbService,
          index: this.edit.index,
          category: "services",
          operation: "edit",
          api_version: this.$store.state.businessSettings.api_version,
        };
      } else {
        updatePacket = {
          key: {
            userId: this.$store.state.user.userId,
            tenantId: this.$store.state.user.tenantId,
          },
          subject: dbService,
          category: "services",
          operation: "add",
          api_version: this.$store.state.businessSettings.api_version,
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.toggleCreationActive();
    },
  },
  created() {},
  components: {
    ItemTile,
    ServiceCreation,
    ServiceDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-services-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .service-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .service-item {
      margin: 30px;
    }
  }
}
</style>
